import React from "react";
import Header from "parts/Header";
import Footer from "parts/Footer";
import FounderHero from "parts/FounderHero";

const FounderPage = () => {
  return (
    <>
      <Header />
      <FounderHero />
      <Footer />
    </>
  );
};

export default FounderPage;
